<template>
  <form-card
    :heading="$t('title.resetPassword')"
    :description="$t('subtitle.resetPassword')"
    :error-message="errorMessage"
    @submit="handleRequestPasswordReset"
  >
    <template #content>
      <form-field
        v-slot="props"
        :label="$t('placeholder.password')"
        rules="required|min:6"
        input-id="password"
      >
        <base-input
          v-model="password"
          v-bind="props"
          type="password"
        />
      </form-field>
      <form-field
        v-slot="props"
        :label="$t('placeholder.confirmPassword')"
        rules="required|confirmed:password"
      >
        <base-input
          v-model="confirmPassword"
          v-bind="props"
          type="password"
        />
      </form-field>
    </template>
    <template #footer>
      <button-primary
        :text="$t('button.reset')"
      />
    </template>
  </form-card>
</template>

<script>
  import FormCard from '@/components/form/form-card'
  import ButtonPrimary from '@/components/button/button-primary'
  import { mapActions } from 'vuex'
  export default {
    components: { FormCard, ButtonPrimary },
    data () {
      return {
        password: '',
        confirmPassword: '',
        errorMessage: ''
      }
    },
    methods: {
      ...mapActions('user', ['resetPassword']),
      handleRequestPasswordReset () {
        this.resetPassword({
          token: this.$route.query.token,
          username: this.$route.params.email,
          password: this.password
        })
          .then(() => {
            this.$emit('password-reset')
          })
          .catch(() => {
            this.errorMessage = this.$t('backend.user.error.tokenResetLinkExpired')
          })
      },
    }
  }
</script>
